module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAMElEQVRIx2MoXXWbRohh1OhRo/EbvevqWxohhnCaAYahCWgYIDSMxtEsM2r0QBkNAG/2EKEtWLomAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/bw.png
// module id = 787
// module chunks = 0